<template>
    <div id="not-found-page">
        <p>
            {{text}}
        </p>
    </div>
</template>

<script>
    export default {
        name: 'not-found-page',
        data() {
            return {
                text: 'page 404'
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/NotFoundPage/NotFoundPage.vue